export const FETCH_SIMILAR_REQUEST = 'similar/FETCH_REQUEST';
export const FETCH_SIMILAR_SUCCESS = 'similar/FETCH_SUCCESS';
export const FETCH_SIMILAR_FAILURE = 'similar/FETCH_FAILURE';
export const VOTE_SUBMIT_START = 'similar/VOTE_SUBMIT_START';
export const VOTE_SUBMIT_END = 'similar/VOTE_SUBMIT_END';
